var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classNames from "classnames";
import { MediaQuery } from "../../responsive/MediaQuery";
import { rippleImageCls, rippleImageInactiveCls, screenExtraSmallMax, screenSmall, screenMediumMax, screenLarge } from "./Ripple.less";
var RippleImage = /* @__PURE__ */ __name(function RippleImage2(_ref) {
  var _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? true : _ref$isActive, _ref$styleConfig = _ref.styleConfig, styleConfig = _ref$styleConfig === void 0 ? {} : _ref$styleConfig;
  var style = _objectSpread({
    small: null,
    medium: null,
    large: null
  }, styleConfig);
  var imgClassNames = classNames(rippleImageCls, _defineProperty({}, rippleImageInactiveCls, !isActive));
  return /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: 0
  }, /* @__PURE__ */ React.createElement(MediaQuery, {
    maxWidth: screenExtraSmallMax
  }, /* @__PURE__ */ React.createElement("div", {
    className: imgClassNames,
    style: style.small
  })), /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: screenSmall,
    maxWidth: screenMediumMax
  }, /* @__PURE__ */ React.createElement("div", {
    className: imgClassNames,
    style: style.medium
  })), /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: screenLarge
  }, /* @__PURE__ */ React.createElement("div", {
    className: imgClassNames,
    style: style.large
  })));
}, "RippleImage");
export {
  RippleImage
};
